(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$table = document.querySelector(".game-field");
var $3d28d7f1aac198f5$var$tBody = $3d28d7f1aac198f5$var$table.querySelector("tbody");
var $3d28d7f1aac198f5$var$rows = $3d28d7f1aac198f5$var$tBody.querySelectorAll("tr");
var $3d28d7f1aac198f5$var$startButton = document.querySelector(".start");
var $3d28d7f1aac198f5$var$gameScore = document.querySelector(".game-score");
var $3d28d7f1aac198f5$var$restartButton = document.querySelector(".restart");
var $3d28d7f1aac198f5$var$startMessage = document.querySelector(".message-start");
var $3d28d7f1aac198f5$var$loseMessage = document.querySelector(".message-lose");
var $3d28d7f1aac198f5$var$winMessage = document.querySelector(".message-win");
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.state = initialState;
        this.score = 0;
        this.status = "start";
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                $3d28d7f1aac198f5$var$gameScore.textContent = this.score;
                return this.score;
            }
        },
        {
            key: "resetBoard",
            value: function resetBoard() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++)this.state[i][j] = 0;
                this.score = 0;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "inProcess";
                this.resetBoard();
                this.spawnCell();
                this.spawnCell();
                this.changeBoard();
                document.removeEventListener("keydown", this.handleKeyPress);
                document.addEventListener("keydown", this.handleKeyPress);
                $3d28d7f1aac198f5$var$startButton.className = "button restart";
                $3d28d7f1aac198f5$var$startButton.textContent = "Restart";
                $3d28d7f1aac198f5$var$startMessage.remove();
                $3d28d7f1aac198f5$var$winMessage.className = "message message-win hidden";
                $3d28d7f1aac198f5$var$loseMessage.className = "message message-min hidden";
            }
        },
        {
            key: "restart",
            value: function restart() {
                var _this = this;
                $3d28d7f1aac198f5$var$restartButton.removeEventListener("click", this.handleRestart);
                this.handleRestart = function() {
                    _this.resetBoard();
                    _this.status = "start";
                    $3d28d7f1aac198f5$var$winMessage.classList.add("hidden");
                    $3d28d7f1aac198f5$var$loseMessage.classList.add("hidden");
                    _this.start();
                };
                $3d28d7f1aac198f5$var$restartButton.addEventListener("click", this.handleRestart);
            }
        },
        {
            key: "isGameWin",
            value: function isGameWin() {
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.state[i][j] === 2048) {
                        this.status = "win";
                        $3d28d7f1aac198f5$var$winMessage.className = "message message-win";
                    }
                }
            }
        },
        {
            key: "isGameOver",
            value: function isGameOver() {
                var ansver = true;
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (this.state[i][j] === 0) ansver = false;
                    if (i < 3 && this.state[i][j] === this.state[i + 1][j] || j < 3 && this.state[i][j] === this.state[i][j + 1]) ansver = false;
                }
                if (ansver === true) {
                    this.status = "lose";
                    $3d28d7f1aac198f5$var$loseMessage.className = "message message-lose";
                }
            }
        },
        {
            key: "handleKeyPress",
            value: function handleKeyPress(e) {
                if (this.status === "inProcess") switch(e.key){
                    case "ArrowUp":
                        this.moveUp();
                        break;
                    case "ArrowDown":
                        this.moveDown();
                        break;
                    case "ArrowLeft":
                        this.moveLeft();
                        break;
                    case "ArrowRight":
                        this.moveRight();
                        break;
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                var previousState = JSON.stringify(this.state);
                var newState = [
                    0,
                    1,
                    2,
                    3
                ].map(function(col) {
                    var column = _this.state.map(function(row) {
                        return row[col];
                    }).filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var i = column.length - 1; i > 0; i--)if (column[i] === column[i - 1]) {
                        column[i] *= 2;
                        column[i - 1] = 0;
                        _this.score += column[i];
                    }
                    var compressed = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(Array(4 - compressed.length).fill(0)).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(compressed));
                });
                this.state = [
                    0,
                    1,
                    2,
                    3
                ].map(function(row) {
                    return newState.map(function(col) {
                        return col[row];
                    });
                });
                if (JSON.stringify(this.state) !== previousState) this.spawnCell();
                this.changeBoard();
                this.isGameWin();
                this.isGameOver();
                this.getScore();
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                var previousState = JSON.stringify(this.state);
                var newState = this.state.map(function(row) {
                    var filtered = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
                        filtered[i] *= 2;
                        filtered[i + 1] = 0;
                        _this.score += filtered[i];
                    }
                    var compressed = filtered.filter(function(cell) {
                        return cell !== 0;
                    });
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(compressed).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(Array(4 - compressed.length).fill(0)));
                });
                this.state = newState;
                if (JSON.stringify(this.state) !== previousState) this.spawnCell();
                this.changeBoard();
                this.isGameWin();
                this.isGameOver();
                this.getScore();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                var previousState = JSON.stringify(this.state);
                var newState = this.state.map(function(row, rowIndex) {
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    var filtered = reversed.filter(function(cell) {
                        return cell !== 0;
                    });
                    var merged = Array(4).fill(false);
                    for(var i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1] && !merged[i] && !merged[i + 1]) {
                        filtered[i] *= 2;
                        filtered[i + 1] = 0;
                        merged[i] = true;
                        _this.score += filtered[i];
                    }
                    var compressed = filtered.filter(function(cell) {
                        return cell !== 0;
                    });
                    var result = (0, $227c6742e0ff6f82$export$71511d61b312f219)(compressed).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(Array(4 - compressed.length).fill(0))).reverse();
                    return result;
                });
                this.state = newState;
                if (JSON.stringify(this.state) !== previousState) this.spawnCell();
                this.changeBoard();
                this.isGameWin();
                this.isGameOver();
                this.getScore();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                var previousState = JSON.stringify(this.state);
                var newState = [
                    0,
                    1,
                    2,
                    3
                ].map(function(col) {
                    var column = _this.state.map(function(row) {
                        return row[col];
                    }).filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                        column[i] *= 2;
                        column[i + 1] = 0;
                        _this.score += column[i];
                    }
                    var compressed = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(compressed).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(Array(4 - compressed.length).fill(0)));
                });
                this.state = [
                    0,
                    1,
                    2,
                    3
                ].map(function(row) {
                    return newState.map(function(col) {
                        return col[row];
                    });
                });
                if (JSON.stringify(this.state) !== previousState) this.spawnCell();
                this.changeBoard();
                this.isGameWin();
                this.isGameOver();
                this.getScore();
            }
        },
        {
            key: "spawnCell",
            value: function spawnCell() {
                var nullCells = [];
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.state[i][j] === 0) nullCells.push({
                        x: i,
                        y: j
                    });
                }
                if (nullCells.length !== 0) {
                    var randomCell = Math.floor(Math.random() * nullCells.length);
                    var _nullCells_randomCell = nullCells[randomCell], x = _nullCells_randomCell.x, y = _nullCells_randomCell.y;
                    this.state[x][y] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "changeBoard",
            value: function changeBoard() {
                for(var row = 0; row < $3d28d7f1aac198f5$var$rows.length; row++){
                    var rowCells = $3d28d7f1aac198f5$var$rows[row].querySelectorAll("td");
                    for(var i = 0; i < rowCells.length; i++){
                        var value = this.state[row][i];
                        if (value !== 0) {
                            rowCells[i].textContent = value;
                            rowCells[i].className = "field-cell field-cell--".concat(value);
                        } else {
                            rowCells[i].textContent = "";
                            rowCells[i].className = "field-cell";
                        }
                    }
                }
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$board = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
document.addEventListener("DOMContentLoaded", function() {
    var game = new (0, (/*@__PURE__*/$parcel$interopDefault($3d28d7f1aac198f5$exports)))($197cd56b15c33885$var$board);
    var startButton = document.querySelector(".start");
    startButton.addEventListener("click", function() {
        game.start();
    });
});

})();
//# sourceMappingURL=index.7157a06a.js.map
